"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpData = dumpData;
exports.loadData = loadData;

var _serializeJavascript = _interopRequireDefault(require("serialize-javascript"));

/**
 * We serialize the data using serialize-javascript, which also works with Date,
 * Map, Set, Regexes etc.
 *
 * At first I wanted to just to JSON.stringify and JSON.parse because it simple and
 * safe.
 *
 * But serialize-javascript is much more practical than the JSON API because JSON
 * doesn't support Date, which is so common.
 */
function dumpData(data) {
  return (0, _serializeJavascript["default"])(data, {
    ignoreFunction: true
  });
}

function loadData(data) {
  // deserialize state from 'serialize-javascript' format
  // Note: this should be safe. See https://github.com/yahoo/serialize-javascript#deserializing
  // and https://github.com/jaredpalmer/after.js/pull/164.
  // eslint-disable-next-line no-eval
  return eval('(' + data + ')');
}